module.exports = __webpack_public_path__ + "static/media/ASIAKASTIETO_black.8e8c9d42.svg";